$(document).on('click','#SearchClose',function(){$(document).find('.js').removeClass('js-drawer-open js-drawer-open--search lock-scroll');$(document).find('.site-header__search-container').removeClass('is-active');});

// Fix embroidery price per currency
var bondepEmbPrices = { NOK: '200,00 kr', SEK: '200,00 kr', DKK: '150,00 kr', GBP: '£15,00', EUR: '€18,00' };
function bondepUpdateEmbPrice() {
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'NOK';
    var p = bondepEmbPrices[cur];
    if (!p) return;
    document.querySelectorAll('span.a_p_t').forEach(function(el) { if (el.textContent !== p) el.textContent = p; });
}
new MutationObserver(bondepUpdateEmbPrice).observe(document.body, { childList: true, subtree: true });
setInterval(bondepUpdateEmbPrice, 300);
